const locale = {
    placeholder: 'Vælg tid',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/da_DK.tsx